
import React from 'react';
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle, CardFooter } from "@/components/ui/card";
import { Loader2 } from "lucide-react";
import OAuthLogin from './OAuthLogin';

interface EmailStepProps {
  email: string;
  setEmail: (email: string) => void;
  emailError: string;
  onContinue: (e: React.FormEvent) => void;
  onBack: () => void;
  isLoading: boolean;
}

const EmailStep: React.FC<EmailStepProps> = ({ 
  email, 
  setEmail, 
  emailError, 
  onContinue, 
  onBack,
  isLoading
}) => {
  return (
    <Card className="w-full max-w-md">
      <CardHeader>
        <CardTitle className="text-center">EasyDJ+ Vérification</CardTitle>
      </CardHeader>
      <CardContent>
        <form onSubmit={onContinue}>
          <div className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="email">Adresse email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="votre@email.com"
                className={`h-12 text-base ${emailError ? 'border-red-500' : ''}`}
                autoComplete="email"
                disabled={isLoading}
              />
              {emailError && (
                <p className="text-sm text-red-500 mt-1">{emailError}</p>
              )}
            </div>
            <Button type="submit" className="w-full h-12" disabled={isLoading}>
              {isLoading ? (
                <>
                  <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                  Envoi en cours...
                </>
              ) : (
                "Vérifier mon email"
              )}
            </Button>
          </div>
        </form>
        
        {/* Add OAuth login options */}
        <div className="mt-6">
          <OAuthLogin />
        </div>
      </CardContent>
      <CardFooter className="flex justify-start">
        <Button 
          variant="outline" 
          onClick={onBack}
          className="text-sm"
          disabled={isLoading}
        >
          Retour
        </Button>
      </CardFooter>
    </Card>
  );
};

export default EmailStep;
